import { escape as l } from "./utils/escape.js";
import { hasNativeEmojiSupport as n, substituteUnicodeForColonified as p } from "./utils/emoji.js";
import { encodeAttributes as m } from "./utils/attribute-encoding.js";
import { MENTION_CLASS as o } from "./constants.js";
class $ {
  schema;
  config;
  text;
  nodeNameMap = {
    bold: "b",
    italic: "i",
    anchor: "a",
    code: "code",
    span: "span"
  };
  constructor(e, t) {
    this.schema = e, this.config = t, this.text = "";
  }
  serializeNode(e) {
    const t = [];
    return e.content.forEach((a) => {
      let s = a.marks || [];
      switch (s = this.filterSerializableMarks(s), this.maybeCloseMarks(t, s), a.type) {
        case this.schema.nodes.hardBreak:
          this.text += "<br>";
          break;
        case this.schema.nodes.text:
          this.maybeOpenMarks(t, s), this.serializeText(a);
          break;
        case this.schema.nodes.template:
          this.maybeOpenMarks(t, s), this.serializeTemplate(a);
          break;
        case this.schema.nodes.mention:
          this.serializeMention(a);
          break;
        case this.schema.nodes.aiPromptData:
          this.serializeAiPromptData(a);
          break;
        case this.schema.nodes.marker:
          break;
        case this.schema.nodes.inlineImage:
          this.serializeImage(a);
          break;
        default:
          throw new Error("Invalid node type in text");
      }
    }), this.maybeCloseMarks(t, []), this.text;
  }
  filterSerializableMarks(e) {
    return e.filter((t) => t.type.spec.serializable !== !1);
  }
  maybeCloseMarks(e, t) {
    if (e.filter((i) => !t.includes(i)).length === 0)
      return;
    const s = e.pop();
    if (!s)
      throw new Error("unreachable");
    this.addClosingTag(s.type), this.maybeCloseMarks(e, t);
  }
  maybeOpenMarks(e, t) {
    t.filter((s) => !e.includes(s)).forEach((s) => {
      e.push(s), this.addOpeningTag(s);
    });
  }
  serializeText(e) {
    let t = e.text ?? "";
    n() || (t = p(t)), this.text += this.escape(t);
  }
  serializeTemplate(e) {
    this.text += `{{${this.escape(e.attrs.attributePath)}`, e.attrs.fallback && (this.text += `|fallback:"${this.escape(e.attrs.fallback)}"`), this.text += "}}";
  }
  serializeMention(e) {
    this.text += `<a class="${o}" href="${this.escape(e.attrs.uri)}">${this.escape(
      e.attrs.name
    )}</a>`;
  }
  serializeAiPromptData(e) {
    let t = "<span data-ai-prompt-data";
    Object.entries(e.attrs).forEach(([a, s]) => {
      if (s) {
        const i = a.replace(/[A-Z]/g, (r) => `-${r.toLowerCase()}`);
        t += ` data-prompt-data-${i}="${this.escape(s)}"`;
      }
    }), this.text += `${t}></span>`;
  }
  serializeImage(e) {
    const { displayWidth: t, width: a, src: s, linkUrl: i, text: r, className: c } = e.attrs;
    let h = `<img class="${o} inline-image" src="${this.escape(s)}" width="${// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    t || a}"${r ? ` alt="${this.escape(r)}"` : ""}${c ? ` data-class-name="${this.escape(c)}"` : ""}>`;
    i && (h = `<a href="${this.escape(i)}">${h}</a>`), this.text += h;
  }
  addClosingTag(e) {
    this.text += `</${this.nodeNameMap[e.name]}>`;
  }
  addOpeningTag(e) {
    this.text += `<${this.nodeNameMap[e.type.name]}`, e.attrs && this.addAttrs(e), this.text += ">";
  }
  addAttrs(e) {
    Object.keys(e.attrs).forEach((t) => {
      const a = m(e.attrs[t]), s = this.escape(a);
      s && (this.text += ` ${t}="${s}"`);
    });
  }
  escape(e) {
    return l(e);
  }
}
export {
  $ as TextSerializer
};
